import {
  Component,
  input,
  InputSignal,
} from '@angular/core';

@Component({
  selector: 'app-form-wrapper',
  templateUrl: './form-wrapper.component.html',
  styleUrl: './form-wrapper.component.scss',
})
export class FormWrapperComponent {

  public readonly title: InputSignal<string> = input<string>('');

}
